module.exports = __webpack_public_path__ + "img/in-screen.a344ece2.svg";